import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    learnMoreButton: 'Learn more',
    radioIsB2b: 'Yes, it’s a B2B SEPA mandate',
    radioIsNotB2b: 'No, it’s not a B2B SEPA mandate',
    subTitle:
      'Only mandates called "**Business to business**" (B2B) or "**Interentreprises**" require that you provide us with a signed mandate to authorize direct debits.',
    title: 'Is it a B2B SEPA mandate?',
  },
  fr: {
    learnMoreButton: 'En savoir plus',
    radioIsB2b: 'Oui, c’est un mandat SEPA interentreprises',
    radioIsNotB2b: 'Non, ce n’est pas un mandat SEPA interentreprises',
    subTitle:
      'Seuls les mandats dits "**Interentreprises**" ou "**Business to business**" (B2B) nécessitent que vous nous fournissiez un mandat signé pour autoriser les prélèvements.',
    title: 'Est-ce un mandat SEPA interentreprises\xA0?',
  },
});

export default locales;
